import {css} from 'aphrodite';
import React from 'react';

import {PROCESS_TASK_DETAILS_PAGE_STYLES} from '../ProcessTaskDetailsPageConstants';

export default function FormattedTextField({text}: {text: string}): JSX.Element {
  return <span className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}>{text}</span>;
}
